

//import {afterDomUpdate} from '../util.js';
import { DateRange } from "./date-range.js";
import "./extend/date.js";
import "./extend/object.js";
import "./accordion.js";


export class Calendar {


   constructor(element, options) {

      this.options = null;
      this.htmlParent = null;
      this.htmlElement = null;
      this.htmlWrapper = null;
      this.appointments = [];
      this.rendering = false;
      this.columns = null;
      this.parentWidth = null;
      this.rendering = true;
 
      let defaults = {
         columns:    "auto",
         dayWidth:   200,
         dayHeight:  200,
         dateRange:  { from: null, to: null },
         displayMode: 'month',
         accordion: false,
         autoAppend: false
      };

      this.options = Object.extend(true, defaults, options);


      this.htmlParent = typeof element === 'string' ? document.querySelector(element) : element;

      window.onresize = () => {
         window.requestAnimationFrame(() => {
            if (this.htmlWrapper) this.render();
         });
      }

      /*
      const resizeObserver = new ResizeObserver(entries => {
         let width = 0;
         for (let entry of entries) {
            if(entry.contentBoxSize) width = entry.contentBoxSize.inlineSize;
            else                     width = entry.contentRect.width;
         }

         if (this.parentWidth != width) {
            this.parentWidth = width;
            if (!this.rendering) this.render();
         }

      });

      resizeObserver.observe(this.htmlParent);
      */



      /*
      if (this.options.autoAppend) {
         window.addEventListener('scroll', () => {
            let windowRelativeBottom = document.documentElement.getBoundingClientRect().bottom;
            if (windowRelativeBottom <= document.documentElement.clientHeight + 50) {

               this.onSectionLoading().then(() => {
                  let start = new Date(this.currentRange.to);
                  start.nextDay();
                  this.currentRange = start.getMonthRange(1);
                  this.renderMonth(this.currentRange);
               });

            }
         });
      }
      */
   }

   setDaySize(width, height) {
      this.options.dayWidth = width;
      this.options.dayHeight = height;
   }

   setColumns(columns) {
      this.options.columns = columns;
   }



   setDateRange(from, to) {
      this.options.dateRange = new DateRange(from, to);
   }

   async onGetAppointments(from, to) {
      return [];
   }

   onSectionRendered(grid) {

   }

   clear() {
      if (this.htmlWrapper) this.htmlWrapper.remove();
   }


   render(force) {

      if (!force && (inst.dm.getLastTab() !== 'calendar' || this.parentWidth === window.innerWidth)) return;

      this.calculateLayout();

      this.htmlWrapper.querySelectorAll('.calendar-grid').removeClass('rendered');

      this.htmlWrapper.querySelectorAll('.month-title.active').forEach(element => {
         this.renderMonth(element.parentNode.querySelector('.calendar-grid'), element.getData('dateRange'));
      });

      document.querySelectorAll('.month-title').forEach((item) => {
         item.style.width = this.parentWidth+'px';
      });

      this.htmlWrapper.querySelectorAll('.accordion-panel').addEventListener('transitionend', () => {
         this.rendering = false;
      });

      this.htmlWrapper.querySelectorAll('.accordion-panel').addEventListener('transitionstart', () => {
         this.rendering = true;
      });

   }


   calculateLayout() {

      if (this.options.columns === 'auto') {

         this.parentWidth = window.innerWidth;

         this.columns = Math.min(this.options.columns === "auto" ? Math.floor(this.parentWidth / this.options.dayWidth) : this.options.columns, 7);
         let calculatedDayWidth = (this.parentWidth) / this.columns;
         this.dayWidth = calculatedDayWidth;
      }
      else {
         this.columns = this.options.columns;
         let calculatedDayWidth = (this.parentWidth) / this.columns;
         this.dayWidth = Math.max(this.options.dayWidth, calculatedDayWidth);
      }

   }

   async renderSections(isoCurrent) {

      this.rendering = true;

      this.calculateLayout();

      if (this.htmlWrapper) this.htmlWrapper.remove();
      this.htmlWrapper = this.htmlParent.createElement('div', 'calendar-wrapper');
      //this.htmlWrapper.style.width = this.htmlParent.clientWidth + 'px';

      let range = new Date(this.options.dateRange.from).getMonthRange(1);
      let currentMonth = null;

      while (range.from.isoDate() <= this.options.dateRange.to.isoDate()) {

         let htmlSection = document.querySelector('#tpl-calendar-section').content.cloneNode(true);

         let monthTitle = htmlSection.querySelector('.month-title');
         monthTitle.setStyles({width: this.htmlParent.clientWidth+'px'});
         monthTitle.innerHTML = range.from.getGermanMonthName() + ' ' + range.from.getFullYear();
         monthTitle.id = 'month-' + range.from.isoDate();

         let htmlGrid = htmlSection.querySelector('.calendar-grid');

         this.htmlWrapper.appendChild(htmlSection);
         if (this.options.accordion) {
            monthTitle.setData('dateRange', range);

            this.htmlWrapper.querySelectorAll('.month-title').accordion({
               onOpening: async (monthTitle) => {
                  return await this.renderMonth(htmlGrid, monthTitle.getData('dateRange'));
               }
            });
         }

         if (range.from.isoDate() <= isoCurrent && range.to.isoDate() >= isoCurrent) {
            let acc = await monthTitle.accordion();

            acc.set.onOpened = () => {
               let currentDay = document.querySelector('[data-date="'+isoCurrent+'"]');
               if (currentDay) this.htmlParent.scrollTo(0, currentDay.offsetTop - this.htmlParent.offsetTop);
               acc.set.onOpened = null;
            }
            acc.open();
         }

         range = range.to.getNextMonth().getMonthRange(1);
      }

      setTimeout(() => { this.rendering = false; }, 300);

   }

   async renderMonth(htmlGrid, dateRange) {

      if (htmlGrid.classList.contains('rendered')) return;

      htmlGrid.style.gridTemplateColumns = `repeat(${this.columns}, ${this.dayWidth}px)`;
      htmlGrid.empty();

      let appointments = await this.onGetAppointments(dateRange);

      let grid = new AppointmentGrid(appointments, this.columns, dateRange);

      let gridY = 1;

      if (this.columns === 7) {
         for (let i=0; i<7; ++i) {
            let dayTitle = htmlGrid.createElement('div', 'weekday-title');
            dayTitle.style.gridArea = `1 / ${i+1} / span 1 / span 1`;
            dayTitle.innerHTML = Date.getGermanWeekday(i, true);
         }
         gridY++;
      }

      for (let y=0; y<grid.getDayGroups().length; ++y) {
         let dayGroup = grid.getDayGroups()[y];
         dayGroup.max++;

         for (let x=0; x<dayGroup.days.length; ++x) {

            let day = dayGroup.days[x];

            if (new Date(Date.fromString(day.isoDate)).inTimespan(dateRange.from, dateRange.to)) {
               this.renderDay(htmlGrid, Number(x)+1, gridY, day, dayGroup.max+1);

               for (let slot=0; slot<day.slots.length; ++slot) {
                  let item = day.slots[slot];
                  if (typeof item === 'object') {
                     this.renderAppointmentContainer(htmlGrid, (Number(x)+1), gridY+Number(slot)+Number(1), item.span, item.app.data);
                  }
               }
            }
         }

         gridY += (dayGroup.max + 1);

      }

      this.onSectionRendered(htmlGrid);

      htmlGrid.classList.add('rendered');

   }

   renderDay(htmlElement, x, y, day, maxSlots) {
      let dayDiv = htmlElement.createElement('div', 'calendar-day ' + 'day-' + new Date(Date.fromString(day.isoDate)).getWeekday());
      dayDiv.style.gridArea = `${y} / ${x} / span ${maxSlots} / span 1`;
      dayDiv.style.minHeight = this.options.dayHeight + 'px';
      dayDiv.dataset.date = day.isoDate;
      if (day.isoDate === new Date().isoDate()) {
         dayDiv.classList.add('current');
      }

      let labelDiv = htmlElement.createElement('div', 'day-label');
      labelDiv.dataset.date = day.isoDate;
      labelDiv.style.gridArea = `${y} / ${x} / span 1 / span 1`;
      this.renderDayTitle(labelDiv, day.isoDate);
   }

   renderDayTitle(element, isoDate) {

      if (this.columns === 7) {
         element.innerHTML = new Date(Date.fromString(isoDate)).getDate();
      }
      else {
         element.innerHTML = new Date(Date.fromString(isoDate)).toGermanDate(true);
      }
   }

   renderAppointmentContainer(htmlElement, x, y, span, data) {
      let appDiv = htmlElement.createElement('div', 'appointment');
      appDiv.style.gridArea = `${y} / ${x} / span 1 / span ${span}`;
      this.renderAppointment(appDiv, data);
   }

   createAppointment() {

   }

   onSectionLoading() {
      return new Promise(function(resolve, reject) { resolve(null); });
   }


}

class AppointmentGrid {

   constructor(appList, columns, dateRange) {

      this.lines = 0;
      this.dayGroups = [];
      this.dateRange = null;

      this.dateRange = dateRange;
      this.appList = appList;
      this.grid = { };
      this.dayMap = {};

      // Eine Map erstellen, die alle Tage enthält
      this.dayMap = this.createDays(dateRange, columns);

      // Termine an den betroffenne Tagen registrieren
      for (let app of this.appList) app.setupForAllDays(this.dayMap);

      // Gruppen von Tagen erstellen, die nebeneinander in einer Zeile dargestellt werden.
      this.dayGroups = this.createDayGroups(this.dayMap);


   }

   getDayGroups() { return this.dayGroups; }

   createDayGroups(dayMap) {

      let dayGroups = [];
      let group = { days: [], max: 0, row: 0 };

      // Gruppen mit allen dazugehörigen Tagen erstellen
      for (let key in dayMap) {
         group.days.push(dayMap[key]);
         group.max = Math.max(group.max, dayMap[key].slots.length);
         if (dayMap[key].next === null) {
            dayGroups.push(group);
            group = { days: [], max: 0 };
         }
      }

      return dayGroups;

   }

   createDays(dateRange, groupSize) {

      let date = new Date(dateRange.from);
      let to = new Date(dateRange.to);

      if (groupSize > 2 && date.getWeekday() < groupSize) {
         date.setDate(date.getDate() - date.getWeekday());
      }

      let dayMap = {};

      let cnt = 0;
      let lastDay = null;

      while (date <= to) {
         let isoDate = date.isoDate();
         let day = new CalendarDay(isoDate, !date.inTimespan(this.dateRange.from, this.dateRange.to));

         if (date.getWeekday() === 0) {
            cnt = 0;
         }
         else if (cnt % groupSize !== 0 && lastDay !== null) {
            lastDay.setNextOfGroup(day);
         }
         dayMap[isoDate] = lastDay = day;
         date.nextDay();
         cnt++;
      }

      return dayMap;

   }

   getGridLines() {
      return this.lines;
   }

}

class CalendarDay {

   constructor(isoDate, isDummy) {
      this.slots = [false];
      this.next = null;
      this.isoDate = isoDate;
      this.isDummy = isDummy;
   }

   setNextOfGroup(next) {
      this.next = next;
   }

   getLabel() { return this.isoDate; }

   register(appSpan, index) {
      index = this.getFreeSlot(index);
      this.slots[index] = appSpan;
      return index;
   }

   getFreeSlot(index) {
      if (index !== undefined) {
         for (let i=0; i<index; ++i) this.slots[i] = this.slots[i] === undefined ? false : this.slots[i];
         return index;
      }
      else {
         index = this.slots.indexOf(false);
         if (index === -1) return this.slots.length;
         else return index;
      }

   }

}

export class Appointment {



   constructor(isoDateFrom, isoDateTo, data) {
      this.dates = {}
      this.isoDateFrom = isoDateFrom;
      this.isoDateTo = isoDateTo;
      this.data = data;

   }

   setupForAllDays(dayMap) {

      let date = new Date(Date.fromString(this.isoDateFrom));
      let dateTo = new Date(Date.fromString(this.isoDateTo));

      while (date <= dateTo) {
         if (date.isoDate() in dayMap) {
            let day = dayMap[date.isoDate()];
            if (!day.isDummy) {
               let appSpan = { app: this, span: 1 };
               let slot = day.register(appSpan);

               while ((day = day.next) !== null && day.isoDate <= this.isoDateTo) {
                  date = new Date(Date.fromString(day.isoDate));
                  day.register('-', slot);
                  appSpan.span++;
               }
            }
         }
         date.nextDay();
      }

   }

   hasDay(date) {
      return (this.dateFrom === date
          ||  this.dateTo   === date
          ||  (this.dateFrom < date && this.dateTo > date));
   }

}
